// Sample events data

export interface appEvent {
  // 1. Event Information
  id: number;
  name: string;
  type: string;
  nature: string;
  status:
    | "requested"
    | "planned"
    | "inprogress"
    | "completed"
    | "cancelled"
    | "approved";
  startDate?: Date;
  endDate?: Date;
  venueid: string;
  participants: number;
  budget: number;
  description: string;

  isEventDateFlexible: boolean;
  location: string;

  // 2. Requester Details
  requesterName: string;
  mobileNum: string;
  emailId: string;
  department: string;
  costCenter: string;
  bizEntity: string;

  // 3. Non-residential Events
  nonResStartDate?: Date | string;
  nonResEndDate?: Date | string;
  eventTiming: string;
  eventDuration: "First Half" | "Second Half" | "Full Day" | ""; // First half / Second half / full day (9 am - 5 pm)

  // 4. Event Requirements
  ohpProjector: boolean; // yes / No
  seatingStyle: "Round" | "Theatre" | "Classroom" | ""; // Round / Theatre / classroom
  flipChart: boolean;
  breakOutRooms: boolean;
  celebration: "DJ" | "Liveband" | "AV" | ""; // DJ / Liveband / AV
  giftsToParticipants: string;
  othersEventRequirements: string;

  // 5. Snack & Meal
  mornCoffeeBreakTiming: string;
  eveTeaBreakTiming: string;
  numOfVegMeals: number;
  numOfNonVegMeals: number;
  isDinnerRequired: boolean;
  othersSnacknMeals: string;

  // 6. Budgets
  eventBudget: number;
  airBudget: number;
  stayBudget: number;
  railRoadBudget: number;
  avDjBudget: number;
  giftBudget: number;
  priorNightSetupBudget: number;

  // 7. Residential Events
  numSingleRooms: number;
  numDoubleRooms: number;
  groundTransportReqd: boolean;
  numVipRooms: number;
}

const pastWeekEventTemplates = [
  { name: "Client Strategy Workshop", type: "Workshop", location: "Bengaluru", participants: 40, budget: 75000 },
  { name: "Product Roadmap Meeting", type: "Meeting", location: "Mumbai", participants: 25, budget: 45000 },
  { name: "Leadership Training", type: "Training", location: "Delhi", participants: 60, budget: 120000 },
  { name: "Partner Connect", type: "Conference", location: "Chennai", participants: 120, budget: 180000 },
  { name: "Sales Enablement Session", type: "Training", location: "Hyderabad", participants: 45, budget: 85000 },
  { name: "Team Planning Meet", type: "Meeting", location: "Pune", participants: 30, budget: 50000 },
  { name: "Marketing Ideas Workshop", type: "Workshop", location: "Kolkata", participants: 35, budget: 65000 },
] as const;

const createPastWeekEvent = (index: number): appEvent => {
  const eventDate = new Date();
  eventDate.setDate(eventDate.getDate() + (index + 1));
  eventDate.setHours(0, 0, 0, 0);

  const event = pastWeekEventTemplates[index];

  return {
    id: index + 4,
    venueid: "not assigned",
    status: "requested",
    name: event.name,
    type: event.type,
    nature: "Non-Residential",
    startDate: eventDate,
    endDate: eventDate,
    location: event.location,
    participants: event.participants,
    budget: event.budget,
    description: `requested ${event.type.toLowerCase()} to be held in ${event.location}.`,
    isEventDateFlexible: false,
    requesterName: "Events Team",
    mobileNum: "+91 98765 43210",
    emailId: "events@example.com",
    department: "Marketing",
    costCenter: "Marketing",
    bizEntity: "HB EventsPro",
    nonResStartDate: eventDate,
    nonResEndDate: eventDate,
    eventTiming: "9:00 AM - 5:00 PM",
    eventDuration: "Full Day",
    ohpProjector: true,
    seatingStyle: "Theatre",
    flipChart: false,
    breakOutRooms: false,
    celebration: "",
    giftsToParticipants: "N/A",
    othersEventRequirements: "N/A",
    mornCoffeeBreakTiming: "10:30 AM - 11:00 AM",
    eveTeaBreakTiming: "4:00 PM - 4:30 PM",
    numOfVegMeals: event.participants,
    numOfNonVegMeals: 0,
    isDinnerRequired: false,
    othersSnacknMeals: "Tea, coffee, and cookies",
    eventBudget: event.budget,
    airBudget: 0,
    stayBudget: 0,
    railRoadBudget: 0,
    avDjBudget: 0,
    giftBudget: 0,
    priorNightSetupBudget: 0,
    numSingleRooms: 0,
    numDoubleRooms: 0,
    groundTransportReqd: false,
    numVipRooms: 0,
  };
};

export const sampleEvents: appEvent[] = [
  {
    id: 1,
    venueid: "not assigned",
    status: "completed",

    // 1. Event Information
    name: "Annual Tech Conference",
    type: "Conference",
    nature: "Non-Residential",
    budget: 500000,
    participants: 500,
    startDate: new Date("2025-10-10"),
    endDate: new Date("2025-10-11"),
    isEventDateFlexible: false,
    location: "Bengaluru",
    description: "Annual technology conference with industry leaders",

    // 2. Requester Details
    requesterName: "Anirudh Banger",
    mobileNum: "9886380925",
    emailId: "anirudh.banger@gmail.com",
    department: "Marketing",
    costCenter: "Marketing",
    bizEntity: "",

    // 3. Residential Events
    numSingleRooms: 0,
    numDoubleRooms: 0,
    groundTransportReqd: false,
    numVipRooms: 0,

    // 4. Non-residential Events
    // are these 2 field redundant as they already exist in event information?
    nonResStartDate: new Date("2025-10-10"),
    nonResEndDate: new Date("2025-10-11"),
    eventTiming: "9 am - 5 pm",
    eventDuration: "Full Day", // First half / Second half / full day (9 am - 5 pm)

    // 4. Event Requirements
    ohpProjector: true, // yes / No
    seatingStyle: "Theatre", // Round / Theatre / classroom
    flipChart: false,
    breakOutRooms: true,
    celebration: "DJ", // DJ / Liveband / AV
    giftsToParticipants: "",
    othersEventRequirements: "",

    // 5. Snack & Meal
    mornCoffeeBreakTiming: "10:30 AM - 11:00 AM",
    eveTeaBreakTiming: "4:00 PM - 4:30 PM",
    numOfVegMeals: 250,
    numOfNonVegMeals: 250,
    isDinnerRequired: false,
    othersSnacknMeals: "tea, coffee, cookies",

    // 6. Budgets
    eventBudget: 500000,
    airBudget: 0,
    stayBudget: 0,
    railRoadBudget: 0,
    avDjBudget: 25000,
    giftBudget: 0,
    priorNightSetupBudget: 0,
  },

  {
    id: 2,
    venueid: "",
    status: "requested",

    name: "Sales Team Workshop",
    type: "Workshop",
    nature: "Non-Residential",
    isEventDateFlexible: false,
    startDate: new Date("2025-10-15"),
    endDate: new Date("2025-10-22"),
    location: "Mumbai",
    participants: 50,
    budget: 150000,
    description: "Sales training and team building workshop",

    // 2. Requester Details
    requesterName: "Anurag Banerjee",
    mobileNum: "9876543210",
    emailId: "infoabconsults@gmail.com",
    department: "Sales",
    costCenter: "Sales",
    bizEntity: "",

    // 3. Residential Events
    numSingleRooms: 20,
    numDoubleRooms: 15,
    groundTransportReqd: true,
    numVipRooms: 2,

    // 4. Non-residential Events
    // are these 2 field redundant as they already exist in event information?
    nonResStartDate: new Date("2025-10-15"),
    nonResEndDate: new Date("2025-10-15"),
    eventTiming: "9 am - 5 pm",
    eventDuration: "Full Day", // First half / Second half / full day (9 am - 5 pm)

    // 4. Event Requirements
    ohpProjector: true, // yes / No
    seatingStyle: "Classroom", // Round / Theatre / classroom
    flipChart: true,
    breakOutRooms: true,
    celebration: "Liveband", // DJ / Liveband / AV
    giftsToParticipants: "Notebooks, pens, tshirts",
    othersEventRequirements: "Bar with cocktails, mocktails",

    // 5. Snack & Meal
    mornCoffeeBreakTiming: "10:30 AM - 11:00 AM",
    eveTeaBreakTiming: "4:00 PM - 4:30 PM",
    numOfVegMeals: 25,
    numOfNonVegMeals: 25,
    isDinnerRequired: true,
    othersSnacknMeals: "tea, coffee, cookies",

    // 6. Budgets
    eventBudget: 150000,
    airBudget: 20000,
    stayBudget: 100000,
    railRoadBudget: 20000,
    avDjBudget: 10000,
    giftBudget: 0,
    priorNightSetupBudget: 0,
  },
  {
    id: 3,
    venueid: "",
    status: "approved",

    name: "Product Launch Event",
    type: "Product Launch",
    nature: "Non-Residential",
    isEventDateFlexible: false,
    startDate: new Date("2025-10-15"),
    endDate: new Date("2025-10-15"),
    location: "Delhi",
    participants: 1000,
    budget: 450000,
    description: "Launch event for our new product line",

    // 2. Requester Details
    requesterName: "Vinod Kumar",
    mobileNum: "9876543210",
    emailId: "infoabconsults@gmail.com",
    department: "Marketing",
    costCenter: "Marketing",
    bizEntity: "",

    // 3. Residential Events
    numSingleRooms: 0,
    numDoubleRooms: 0,
    groundTransportReqd: false,
    numVipRooms: 0,

    // 4. Non-residential Events
    // are these 2 field redundant as they already exist in event information?
    nonResStartDate: new Date("2025-10-15"),
    nonResEndDate: new Date("2025-10-15"),
    eventTiming: "5 pm - 11 pm",
    eventDuration: "Second Half", // First half / Second half / full day (9 am - 5 pm)

    // 4. Event Requirements
    ohpProjector: true, // yes / No
    seatingStyle: "Theatre", // Round / Theatre / classroom
    flipChart: false,
    breakOutRooms: false,
    celebration: "DJ", // DJ / Liveband / AV
    giftsToParticipants: "Notebooks, pens, tshirts",
    othersEventRequirements: "Bar with cocktails, mocktails",

    // 5. Snack & Meal
    mornCoffeeBreakTiming: "N/A",
    eveTeaBreakTiming: "4:00 PM - 4:30 PM",
    numOfVegMeals: 500,
    numOfNonVegMeals: 500,
    isDinnerRequired: true,
    othersSnacknMeals: "tea, coffee, cookies",

    // 6. Budgets
    eventBudget: 450000,
    airBudget: 0,
    stayBudget: 0,
    railRoadBudget: 0,
    avDjBudget: 50000,
    giftBudget: 0,
    priorNightSetupBudget: 0,
  },
  ...Array.from({ length: 7 }, (_, index) => createPastWeekEvent(index)),
];
